import React, { useMemo, useState } from "react";
import { Tabs } from "@hid-galaxy-ui/galaxy-react";
import Categories from "./categories";
import RequirementManagement from "./requirement-management";
import TestCaseManagement from "./testcase-management";
import FeatureManagement from "./feature-management/index";
import "./ValidationManagement.scss";

type Props = { readOnly?: boolean };

const ValidationManagement: React.FC<Props> = ({ readOnly = false }) => {
  const [activeTab, setActiveTab] = useState<string>("categories");

  const handleTabChange = (_: any, key: string) => {
    setActiveTab(key);
  };

  const tabItems = useMemo(
    () => [
      {
        key: "categories",
        label: "Categories",
        content: <Categories readOnly={readOnly} />,
      },
      {
        key: "test-case-management",
        label: "Test Case Management",
        content: <TestCaseManagement readOnly={readOnly} />,
      },
      {
        key: "requirement-management",
        label: "Requirement Management",
        content: <RequirementManagement readOnly={readOnly} />,
      },
      {
        key: "feature-management",
        label: "Feature Management",
        content: <FeatureManagement readOnly={readOnly} />,
      },
    ],
    [readOnly]
  );

  return (
    <div className="validation-management">
      <Tabs
        theme="frameless"
        selectedKey={activeTab}
        items={tabItems}
        onClick={handleTabChange}
      />
    </div>
  );
};

export default ValidationManagement;
